import Mutations from '../../odata/mutations';

export default { ...new Mutations('checklistTransaction'), ...new Mutations('checklistTransactions') };
